"use client"

import { createContext, use } from "react"
import { ResolvedProductData } from "./useResolvedProductData"

const productContext = createContext(undefined as any)

export const ProductProvider = productContext.Provider

export function useProductContext() {
  const data: ResolvedProductData = use(productContext)

  if (!data) {
    throw new Error("useProductContext must be used within a ProductContext provider")
  }

  return data
}
